"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcePageOverview = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const react_router_dom_1 = require("react-router-dom");
const configContext_1 = require("../../context/configContext");
const ResourcePageOverview = (props) => {
    const config = (0, configContext_1.useConfig)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement(Container_1.default, { className: "resource-page-overview pb-5" },
        react_1.default.createElement("div", { className: "d-flex mt-3" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h1", { className: "display-4 mt-2" },
                    "R\u00E4ume von \u00AB",
                    config.name,
                    "\u00BB"),
                react_1.default.createElement("h4", { className: "font-weight-normal" },
                    react_1.default.createElement("a", { href: config.website }, config.website))),
            react_1.default.createElement("div", { className: "ml-auto" },
                react_1.default.createElement(Button_1.default, { variant: "outline-secondary", onClick: () => navigate(`/manager/`) }, "Login"))),
        config.getVisibleResources().map((resource) => {
            const link = `/resources/${config.tenantId}/${resource.id}/`;
            return (react_1.default.createElement(react_1.default.Fragment, { key: resource.id },
                react_1.default.createElement(Row_1.default, null,
                    react_1.default.createElement(Col_1.default, null,
                        react_1.default.createElement("h2", { className: "display-5 mt-4 mb-3" },
                            react_1.default.createElement(react_router_dom_1.Link, { to: link, className: "text-dark" }, resource.resourceItem.title)))),
                react_1.default.createElement(Row_1.default, null,
                    react_1.default.createElement(Col_1.default, { sm: { span: 6 }, className: "mb-sm-40" },
                        react_1.default.createElement(react_router_dom_1.Link, { to: link, className: "text-dark" },
                            react_1.default.createElement("img", { src: resource.resourceItem.getImageUrls()[0], alt: "", className: "img-fluid img-thumbnail" }))),
                    react_1.default.createElement(Col_1.default, { sm: { span: 6 }, xl: { span: 5 } },
                        react_1.default.createElement(react_markdown_1.default, { children: resource.resourceItem.description }),
                        react_1.default.createElement(Button_1.default, { variant: "dark", size: "lg", href: link },
                            resource.resourceItem.title,
                            " buchen")))));
        })));
};
exports.ResourcePageOverview = ResourcePageOverview;
